import { AuthenticationService } from 'lib/ng2-sapmp/src/providers/authentication.service';
import { UserProfileModel } from 'lib/ng2-sapmp/src/models/userprofile';
import { Component, OnInit } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { StepIndicatorService } from 'lib/ng2-sapmp/src/ui-components/step-indicator';
import { BreadCrumbModel } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import {
  GridOptionsModel, ColumnDefinitionsModel, PaginationsModel,
  FetchCriteriaModel
} from 'lib/ng2-sapmp/src/ui-components/custom-grid';
import { BulkReviewService } from './bulk-review.service';
import { UtilityService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { BulkWizardDataService } from './../bulk-wizard-data-service';
import { ANALYTICS_CONSTANTS } from 'config';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
declare var logoutCurrentUser: any;

@Component({
  selector: 'app-bulk-users-review',
  providers: [BulkReviewService, BulkWizardDataService],
  templateUrl: './bulk-review.component.html',
  styleUrls: ['./../bulk-users.component.scss']
})
export class BulkReviewComponent implements OnInit {
  breadCrumbs: BreadCrumbModel[];
  gridOptions: GridOptionsModel = null;
  user: UserProfileModel;
  csrPermissionSubmitButton: boolean;
  userColumns: Array<ColumnDefinitionsModel> = [
    { field: 'firstName', caption: 'User', enableSorting: true, sortDirection: 'Default', type: 'TEXT', cssClass: 'username', priority: 1 },
    { field: 'email', caption: 'Email', type: 'TEXT', priority: 3 },
    { field: 'phoneNumber', caption: 'Contact number', type: 'TEXT', priority: 4 }
  ];

  errorColumns: Array<ColumnDefinitionsModel> = [
    { field: 'errorType', caption: 'Error', enableSorting: true, type: 'TEXT', priority: 1 },
    { field: 'what', caption: 'Details', type: 'TEXT', priority: 2 },
    { field: 'where', caption: 'Location', type: 'TEXT', priority: 3 }
  ];

  paginations: PaginationsModel = {
    recordsPerPage: 20,
    currentPage: 1,
    totalRecords: 0,
    isServerSide: false
  };

  isError = false;
  errorMsg = '';

  constructor(
    private stepindicatorService: StepIndicatorService, private authenticationService: AuthenticationService,
    private breadCrumbService: BreadCrumbService, private activatedRoute: ActivatedRoute,
    private router: Router, private reviewService: BulkReviewService, private utilityService: UtilityService
    , private bulkWizardDataService: BulkWizardDataService, private adobeAnalyticsService: AdobeAnalyticsService,
    private pageLoaderService: PageLoaderService
  ) {

    this.csrPermissionSubmitButton = this.utilityService.checkFieldPermission('bulk-review.submit',
      JSON.parse(sessionStorage.getItem('permissions')).perm);
  }

  ngOnInit() {
    this.authenticationService.setLoginSuccessUrl(this.router.routerState.snapshot.url);
    if (sessionStorage.getItem('bulk-user') === null) {
      this.router.navigate(['/home']);
    } else {

      document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
      this.stepindicatorService.setCurrentStep(this.activatedRoute.snapshot.url[0].path);
      this.user = this.authenticationService.getUser();
      const userData = JSON.parse(sessionStorage.getItem('bulk-user'));
      if (!!userData.items) {
        const data = new Array<any>();
        userData.items.forEach(function (obj) {
          obj.employee.firstName += ' ' + obj.employee.lastName;
          data.push(obj.employee);
        });
        this.setSuccessReview(data);
      } else if (!!userData.errors) {
        this.setErrorReview(userData.errors);
      }
    }
    this.bulkWizardDataService.createPageLoadProperties(this.router.routerState.snapshot.url,
      'Bulk User upload - Review',
      ANALYTICS_CONSTANTS.FRIENDLY_NAME_BULKUPLOAD_STEP3);

  }

  setSuccessReview(userData) {
    this.gridOptions = new GridOptionsModel();
    this.gridOptions.columnDefinitions = this.userColumns;
    this.gridOptions.enableFiltering = false;
    this.paginations.totalRecords = userData.length;
    this.gridOptions.Paginations = this.paginations;
    this.gridOptions.enableSorting = true;
    this.gridOptions.gridData = userData;
  }

  setErrorReview(errorData) {
    this.gridOptions = new GridOptionsModel();
    this.gridOptions.columnDefinitions = this.errorColumns;
    this.gridOptions.enableFiltering = false;
    this.paginations.totalRecords = errorData.length;
    this.gridOptions.Paginations = this.paginations;
    this.gridOptions.enableSorting = true;
    this.gridOptions.gridData = errorData;
    this.isError = true;
  }

  cancel() {
    this.router.navigate(['/bulkUsers/bulk-upload']);
    sessionStorage.setItem('navigationUrl', '/bulkUsers/bulk-upload'); // to check , for restrict direct url hit
    sessionStorage.removeItem('review-status');
  }

  submit() {

    const userData: any = JSON.parse(sessionStorage.getItem('bulk-user'));
    const reviewUrl: string = this.utilityService.getEnvConfig().bulkReviewUrl;
    this.pageLoaderService.setPageLoaderStatus(false);
    this.reviewService.uploadReview(reviewUrl, userData, this.user.companyId).subscribe(responseData => {
      console.log(responseData);
      this.ProcessUpload(responseData);
      this.pageLoaderService.setPageLoaderStatus(true);
    }, error => {
      this.adobeAnalyticsService.CreateSeriveAlertProperties(error.status, error.statusText, 'formResponse');
      if (error.status === 401) {
        this.errorMsg = 'Session Expired.Please login again';
        logoutCurrentUser(true);
      } else if (error.status === 400 && 
        !!error.error[0].errorDescription) { // msg like "Bulk employees limit of 25 exceeded"
        this.errorMsg = JSON.parse(error.error[0].errorDescription).errorMessage;
      } else {
        this.errorMsg = 'We couldn\'t complete your request. Please try again later.';
      }
      this.utilityService.loadFocusOnTop();
      this.pageLoaderService.setPageLoaderStatus(true);
    });
  }

  ProcessUpload(responseData) {

    if (!!responseData.items) {

      if (!!responseData.status && responseData.status === 'COMPLETED') {
        const statusResponse = {
          status: 'completed',
          processedRecords: this.paginations.totalRecords
        };
        sessionStorage.setItem('review-status', JSON.stringify(statusResponse));
        this.router.navigate(['bulkUsers/bulk-confirm']);
      } else {

        let status = 'error';
        if (responseData.items.length === this.paginations.totalRecords) {
          status = 'errorAll';
        }
        const statusResponse = {
          status: status,
          processedRecords: this.paginations.totalRecords
        };
        responseData = Object.assign({}, responseData, statusResponse);
        sessionStorage.setItem('review-status', JSON.stringify(responseData));
        this.router.navigate(['bulkUsers/bulk-confirm']);
      }
    }

  }
}
